import RadioButtonChecked from "@website/icons/components/radio-button-checked";
import RadioButtonUnchecked from "@website/icons/components/radio-button-unchecked";
import { useRadio } from "@website/ui-old/radio/radio.hook";
import styles from "@website/ui-old/radio/radio.module.scss";
import { RadioPropertiesType } from "@website/ui-old/radio/radio.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Radio: FC<RadioPropertiesType> = (properties) => {
  const { inputProps } = useRadio(properties);
  const { className, color, disabled, label, fullWidthLabel } = properties;

  return (
    <label
      className={`${styles["radio"]} ${disabled ? styles["disabled"] : ""} ${
        className ?? ""
      }`}
    >
      <input {...inputProps} className={styles["input"]} />
      <div className={styles["box"]}>
        <RadioButtonUnchecked className={styles["un-checked-icon"]} />
        <RadioButtonChecked
          className={`${styles["checked-icon"]} ${styles[color || "primary"]}`}
        />
        <div className={`${styles["ripple"]} ${styles[color || "primary"]}`} />
      </div>
      <div
        className={`${styles["label"]} ${
          fullWidthLabel && styles["full-width-label"]
        }`}
        hidden={!label}
      >
        {label}
      </div>
    </label>
  );
};

const RadioMemoized = memo(Radio, deepCompare);
/**
 * @deprecated please use @website/ui instead
 */
export { RadioMemoized /**
 * @deprecated please use @website/ui instead
 */ as Radio };
